import React from 'react';
import { Card, CardContent } from './ui/card';
import { Briefcase, Shield, Home, Languages, Scale, HeartHandshake } from 'lucide-react';

const Services = ({ t }) => {
  const iconMap = [Briefcase, Languages, Shield, HeartHandshake, Home, Scale];

  return (
    <section id="services" className="relative py-24 px-4 bg-gradient-to-br from-gray-900 via-black to-gray-900 overflow-hidden">
      {/* Decorative background */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-0 left-1/4 w-96 h-96 bg-gradient-to-br from-red-600/20 to-transparent rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-gradient-to-tl from-orange-600/15 to-transparent rounded-full blur-3xl"></div>
        
        {/* Grid pattern overlay */}
        <div className="absolute inset-0 opacity-[0.02]" style={{
          backgroundImage: 'linear-gradient(rgba(239, 68, 68, 0.5) 1px, transparent 1px), linear-gradient(90deg, rgba(239, 68, 68, 0.5) 1px, transparent 1px)',
          backgroundSize: '64px 64px'
        }}></div>
      </div>
      <div className="container mx-auto relative z-10">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="inline-block px-4 py-2 bg-red-950/50 text-orange-400 rounded-full text-sm font-semibold mb-4 border border-red-900/30">
            {t.nav.services}
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            {t.services.title}
          </h2>
          <p className="text-lg text-gray-400 max-w-2xl mx-auto">
            Comprehensive support throughout your journey to working in Germany
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {t.services.items.map((service, index) => {
            const Icon = iconMap[index];
            return (
              <Card key={index} className="border-0 shadow-lg hover:shadow-xl transition-all duration-300 group hover:-translate-y-1 bg-gradient-to-br from-gray-900 to-black border border-red-900/20">
                <CardContent className="p-8">
                  <div className="w-14 h-14 bg-gradient-to-br from-red-600 to-orange-600 rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform shadow-lg shadow-red-900/30">
                    <Icon className="h-7 w-7 text-white" />
                  </div>
                  <h3 className="text-xl font-bold text-white mb-3">
                    {service.title}
                  </h3>
                  <p className="text-gray-400 leading-relaxed">
                    {service.description}
                  </p>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
